import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  GET_INSTALLATIONS_AUTOCOMPLETE,
  GET_INSTALLATIONS_AUTOCOMPLETE_SUCCESS,
  GET_INSTALLATIONS_AUTOCOMPLETE_ERROR,
  GET_DEVICES_AUTOCOMPLETE,
  GET_DEVICES_AUTOCOMPLETE_SUCCESS,
  GET_DEVICES_AUTOCOMPLETE_ERROR,
  GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE,
  GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_SUCCESS,
  GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_ERROR,
  GET_SIMCARDS_AUTOCOMPLETE,
  GET_SIMCARDS_AUTOCOMPLETE_SUCCESS,
  GET_SIMCARDS_AUTOCOMPLETE_ERROR,
  GET_DISTRIBUTIONS_AUTOCOMPLETE,
  GET_DISTRIBUTIONS_AUTOCOMPLETE_SUCCESS,
  GET_DISTRIBUTIONS_AUTOCOMPLETE_ERROR,
  GET_PROFILES_AUTOCOMPLETE,
  GET_PROFILES_AUTOCOMPLETE_SUCCESS,
  GET_PROFILES_AUTOCOMPLETE_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeInstallation } from '../../models/installation';
import { deserialize as deserializeDevice } from '../../models/device';
import { deserialize as deserializeCustomer } from '../../models/customer';
import { deserialize as deserializeSimcard } from '../../models/simcard';
import { deserialize as deserializeDistribution } from '../../models/distribution';
import { deserialize as deserializeProfile } from '../../models/profile';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.autoComplete;
const autoComplete = (state = initialSettings, action) => {
  switch (action.type) {
    // INSTALLATIONS
    case GET_INSTALLATIONS_AUTOCOMPLETE:
      return {
        ...state,
        installations: {
          ...state.installations,
          elements: [],
          loading: true,
        },
      };
    case GET_INSTALLATIONS_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        installations: {
          ...state.installations,
          elements: deserializeInstallation(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_INSTALLATIONS_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        installations: {
          ...state.installations,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // DEVICES
    case GET_DEVICES_AUTOCOMPLETE:
      return {
        ...state,
        devices: {
          ...state.devices,
          elements: [],
          loading: true,
        },
      };
    case GET_DEVICES_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        devices: {
          ...state.devices,
          elements: deserializeDevice(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_DEVICES_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        devices: {
          ...state.devices,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // INSTALLATION_CUSTOMERS
    case GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: [],
          loading: true,
        },
      };
    case GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: deserializeCustomer(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // SIMCARDS
    case GET_SIMCARDS_AUTOCOMPLETE:
      return {
        ...state,
        simcards: {
          ...state.simcards,
          elements: [],
          loading: true,
        },
      };
    case GET_SIMCARDS_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        simcards: {
          ...state.simcards,
          elements: deserializeSimcard(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_SIMCARDS_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        simcards: {
          ...state.simcards,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // DISTRIBUTIONS
    case GET_DISTRIBUTIONS_AUTOCOMPLETE:
      return {
        ...state,
        distributions: {
          ...state.distributions,
          elements: [],
          loading: true,
        },
      };
    case GET_DISTRIBUTIONS_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        distributions: {
          ...state.distributions,
          elements: deserializeDistribution(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_DISTRIBUTIONS_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        distributions: {
          ...state.distributions,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // PROFILES
    case GET_PROFILES_AUTOCOMPLETE:
      return {
        ...state,
        profiles: {
          ...state.profiles,
          elements: [],
          loading: true,
        },
      };
    case GET_PROFILES_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        profiles: {
          ...state.profiles,
          elements: deserializeProfile(action.data.data),
          pagination: {
            pageNumber: _parseInt(action.data.page_number),
            totalPages: _parseInt(action.data.total_pages),
          },
          loading: false,
        },
      };
    case GET_PROFILES_AUTOCOMPLETE_ERROR:
      return {
        ...state,
        profiles: {
          ...state.profiles,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default autoComplete;



// WEBPACK FOOTER //
// ./reducers/autoComplete/autoComplete.js